// Icon set — UI/UX §8.1 names Phosphor glyphs (House, CalendarStar, BookOpen, Users, UserCircle).
// Re-exported here so screens never import the icon package directly and the set stays small.
import type { Icon as PhosphorIcon } from '@phosphor-icons/react';
import {
  Bell,
  BookOpen,
  Cake,
  CalendarBlank,
  CalendarStar,
  Camera,
  CaretLeft,
  CaretRight,
  ChatCircleText,
  Check,
  CheckCircle,
  Clock,
  Heart,
  House,
  Lock,
  Megaphone,
  PencilSimple,
  SidebarSimple,
  Sparkle,
  UserCircle,
  UserPlus,
  Users,
  WarningCircle,
  X,
} from '@phosphor-icons/react';

export type { PhosphorIcon as IconComponent };

export {
  Bell,
  BookOpen,
  CalendarBlank,
  CalendarStar,
  Camera,
  CaretLeft,
  CaretRight,
  Check,
  CheckCircle,
  Heart,
  House,
  Lock,
  SidebarSimple,
  UserCircle,
  Users,
  X,
};

/** UI/UX §3.7 — one glyph per Notification Type Registry entry (App Flow §2). */
export const NOTIFICATION_ICONS: Record<string, PhosphorIcon> = {
  prompt_reminder: Clock,
  theme_picked: Sparkle,
  drop_day: BookOpen,
  heart_received: Heart,
  editor_rotation: PencilSimple,
  occasion_reminder: Cake,
  new_member_joined: UserPlus,
  archive_unlocked: Lock,
  member_removed: Users,
  admin_transferred: Users,
  auto_fallback_theme: Sparkle,
  compilation_complete: CheckCircle,
  bonus_prompt: ChatCircleText,
};

export const FALLBACK_NOTIFICATION_ICON: PhosphorIcon = Megaphone;
export const ERROR_ICON: PhosphorIcon = WarningCircle;
